export default __webpack_public_path__ + "static/layer-section4-8a79d0655bcd04285121cbec222ef18a.webp";